'use client';

import type { FC, PropsWithChildren } from 'react';
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

const MotionDiv = dynamic(
  async () => {
    const { motion } = await import('framer-motion');
    return function MotionWrapper(props: any) {
      return <motion.div {...props} />;
    };
  },
  { ssr: false }
);

const events = ['scroll', 'touchstart', 'touchmove', 'wheel', 'pointermove', 'mousemove'];

const createListeners = (isRemove: boolean, callback: () => void) => {
  events.forEach(event => {
    if (isRemove) {
      window.removeEventListener(event, callback);
    } else {
      window.addEventListener(event, callback);
    }
  });
};

const IsScrolledWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const listener = () => {
      if (!visible) {
        setVisible(true);
      }
    };

    createListeners(true, listener);
    createListeners(false, listener);

    if (
      !visible &&
      (window.scrollY > 4 ||
        (document.documentElement.scrollTop || document.body.scrollTop) > 4 ||
        window.location.hash)
    ) {
      setVisible(true);
    }

    return () => {
      createListeners(true, listener);
    };
  }, [visible]);

  return (
    <>
      {visible && (
        <MotionDiv
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {children}
        </MotionDiv>
      )}
    </>
  );
};

export default IsScrolledWrapper;
